import React from "react";
import PropTypes from "prop-types";

const StarRating = ({ rating, onRatingChange, editable = false }) => {
  const stars = [1, 2, 3, 4, 5];

  const handleClick = (value) => {
    if (editable && onRatingChange) {
      onRatingChange(value);
    }
  };

  return (
    <div className="star-rating d-flex">
      {stars.map((star) => (
        <div
          key={star}
          onClick={() => handleClick(star)}
          style={{ cursor: editable ? "pointer" : "default" }}
          className="me-1"
        >
          {star <= rating ? (
            <i className="ti ti-star-filled text-warning"></i>
          ) : (
            <i className="ti ti-star text-muted"></i>
          )}
        </div>
      ))}
    </div>
  );
};

StarRating.propTypes = {
  rating: PropTypes.number.isRequired,
  onRatingChange: PropTypes.func,
  editable: PropTypes.bool,
};

export default StarRating;
